'use client'

import { ZapIcon } from 'lucide-react'

import { AccountBanner } from '~/components/account-detail/AccountBanner'
import { Skeleton } from '~/components/component-library/Skeleton'
import { useAutoEarnApy } from '~/hooks/useAutoEarnApy'
import { useNavigation } from '~/hooks/useNavigation'
import { getEarnLabel } from '~/utils/vault'

export const EarnApyBanner = () => {
  const { apy, isLoading: isApyLoading } = useAutoEarnApy()
  const navigate = useNavigation()

  return (
    <AccountBanner
      icon={<ZapIcon className="h-6 w-6 text-white" />}
      title={
        isApyLoading ? (
          <div className="flex items-center space-x-1">
            <div>Earn</div> <Skeleton size="sm" length={3} height={0.5} />
          </div>
        ) : (
          getEarnLabel(apy)
        )
      }
      description="Auto-deposit your idle USDC"
      onClick={() => navigate('/settings/team/general')}
    />
  )
}
